import { render } from "./video-info.vue?vue&type=template&id=36d6581e"
import script from "./video-info.vue?vue&type=script&lang=js"
export * from "./video-info.vue?vue&type=script&lang=js"
script.render = render

export default script